import SmartBadge from './SmartBadge'

export default SmartBadge
